'use client';

import { Fragment } from 'react';

import {
  EnergyEfficiencyFlag,
  type EnergyEfficiencyFlagSpecificProps,
} from '@packages/shared/src/ui/EnergyEfficiencyFlag/EnergyEfficiencyFlag';
import type { EfficiencyFlagOverlay } from '@packages/shared/src/ui/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { EfficiencyFlagOverlayDialog } from '@packages/shared/src/ui/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { useIntl } from 'react-intl';
import { efficiencyFlagMessages } from '@packages/modules/src/LegacyEfficiencyFlag/messages';
import { ProductCardV2DatasheetLink, type Datasheet } from './ProductCardV2.DatasheetLink';

export type ProductCardV2EnergyEfficiencyFlagsProps = {
  flags: readonly (EnergyEfficiencyFlagSpecificProps & {
    overlay?: EfficiencyFlagOverlay;
    datasheet?: Datasheet;
  })[];
};

export const ProductCardV2EnergyEfficiencyFlags = ({
  flags,
}: ProductCardV2EnergyEfficiencyFlagsProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className="grid [grid-template-columns:auto_1fr] items-center gap-1">
      {flags.map(({ datasheet, overlay, ...flagProps }, index) => {
        const componentId = `efficiency-component-${overlay?.title ?? index}`;

        return (
          <Fragment key={overlay?.title ?? index}>
            <EfficiencyFlagOverlayDialog overlay={overlay} aria-describedby={componentId}>
              <EnergyEfficiencyFlag
                {...flagProps}
                aria-label={formatMessage(efficiencyFlagMessages.energyEfficiency)}
              />
            </EfficiencyFlagOverlayDialog>

            <div className="flex flex-col">
              {flags.length > 1 && overlay && (
                <span id={componentId} className="text-size-body3 font-semibold hyphens-auto">
                  {overlay.title}
                </span>
              )}
              {datasheet && (
                <ProductCardV2DatasheetLink datasheet={datasheet} ariaDescribedBy={componentId} />
              )}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};
